import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import printerimg from "../../../../assets/print.png";

import { useItemcodeserialMutation } from "../../../../store/api/serialnoapi";
import { useCompanyserialMutation } from "../../../../store/api/serialnoapi";
import { useWorkOrderserialMutation } from "../../../../store/api/serialnoapi";
import { usePostCreateSerialNoMutation } from "../../../../store/api/serialnoapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";

const PurchaseSerialList = () => {
  const navigate = useNavigate();
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  const [ItemCode_list, setItemCode_list] = useState([]); // item code list api data
  const [select_ItemCode, setselect_ItemCode] = useState(""); // single value select const
  const [ItemcodeserialApi] = useItemcodeserialMutation();
  useEffect(() => {
    const getItemcodeserial = async () => {
      const Itemcodeserial = await ItemcodeserialApi();
      setItemCode_list(Itemcodeserial.data.data);
    };
    getItemcodeserial();
  }, []);
   const [Company_list, setCompany_list] = useState([]); // item code list api data
  const [select_Company, setselect_Company] = useState(""); // single value select const
  const [CompanyserialApi] = useCompanyserialMutation();
  useEffect(() => {
    const getCompanyserial = async () => {
      const Companyserial = await CompanyserialApi();
      setCompany_list(Companyserial.data.data);
    };
    getCompanyserial();
  }, []);
     const [WorkOrder_list, setWorkOrder_list] = useState([]); // item code list api data
  const [select_WorkOrder, setselect_WorkOrder] = useState(""); // single value select const
  const [WorkOrderserialApi] = useWorkOrderserialMutation();
  useEffect(() => {
    const getWorkOrderserial = async () => {
      const WorkOrderserial = await WorkOrderserialApi();
      setWorkOrder_list(WorkOrderserial.data.data);
    };
    getWorkOrderserial();
  }, []);
  // api varibale

  const [CreateSerialNo] = usePostCreateSerialNoMutation();

  // tab1
  const [SerialNo, setSerialNo] = useState("");
 
  // tab2
  const [AmcExpiryDate, setAmcExpiryDate] = useState("");
  const [WarrantyExpiryDate, setWarrantyExpiryDate] = useState("");
  // tab3
  // const [Company, setCompany] = useState("");
  const [WorkOrder, setWorkOrder] = useState("");

  const [select_ParentItemGroup, setselect_ParentItemGroup] = useState("");
  const [ParentItemGroup_list, setParentItemGroup_list] = useState([]);
  const [UnicommerceProductCategoryCode, setUnicommerceProductCategoryCode] =
    useState("");
  const [IsGroup, setIsGroup] = useState("");

  const [selected_default_item_data, setselected_default_item_data] = useState(
    []
  );
  const [selected_tax_item_data, setselected_tax_item_data] = useState([]);
  // console.log('tax:',selected_tax_item_data)
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    SerialNo:false,
    ItemCode:false,
    WarrantyExpiryDate:false,
    AmcExpiryDate:false,
    Company:false,
    WorkOrder:false
  });

  const handleSubmit = async () => {

 

    setFieldErrors({
      SerialNo: false,
      ItemCode: false,
      WarrantyExpiryDate: false,
      AmcExpiryDate: false,
      Company: false,
      WorkOrder: false,
    });

    let hasError = false;
    const newErrors = {
      SerialNo: !SerialNo,
      ItemCode: !select_ItemCode,
      WarrantyExpiryDate: !WarrantyExpiryDate,
      AmcExpiryDate: !AmcExpiryDate,
      Company: !select_Company,
      WorkOrder: !select_WorkOrder,
    };

    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some((error) => error);

    if (!SerialNo) {
      setptype("Error");
      setError("Please Fill Serial No.");
      setShowError(true);
      return;
    }
    if (!select_ItemCode) {
      setptype("Error");
      setError("Please Select Item Code.");
      setShowError(true);
      return;
    }
     if (!WarrantyExpiryDate) {
      setptype("Error");
      setError("Please Select Warranty Expiry Date.");
      setShowError(true);
      return;
    }
     if (!AmcExpiryDate) {
      setptype("Error");
      setError("Please Select Amc Expiry Date.");
      setShowError(true);
      return;
    }
     if (!select_Company) {
      setptype("Error");
      setError("Please Select Company.");
      setShowError(true);
      return;
    }
     if (!select_WorkOrder) {
      setptype("Error");
      setError("Please Select Work Order.");
      setShowError(true);
      return;
    }
    

   
  

  const payload = {
    serial_no: SerialNo,
    item_code: select_ItemCode,
    warranty_expiry_date: WarrantyExpiryDate,
    amc_expiry_date: AmcExpiryDate,
    company: select_Company,
    work_order: select_WorkOrder,
  };

  console.log("create serial number payload:", payload);
    try {
      const response = await CreateSerialNo(payload); // RTK mutation or fetch

       function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Creation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

      setpo_response(response.data);
      setError("Serial No created successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/serialno/serialno-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };

  return (
    <FormLayout
      title="New Serial No"
      breadcrumbs={[
        { label: "Serial No" },
        { label: "Serial No List", url: "/master/serialno/serialno-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            Save
          </Button>

          {/* <Button
            to="/itemgroup/create-item-group"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          /> */}
        </>
      }
    >
       <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            >
              <span style={{ position: "relative", top: "-1px" }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>
          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
               <div className="sidebarbox m-0 px-4 py-2"  style={{height:'100vh'}}>
                  <Tab1
                    SerialNo={{
                      SerialNo: SerialNo,
                      setSerialNo: setSerialNo,
                      SerialNo: SerialNo,
                      Error: fieldErrors.SerialNo,
                    }} //for input text
                    ItemCode={{
                      ItemCode_list: ItemCode_list,
                      setselect_ItemCode: setselect_ItemCode,
                      select_ItemCode: select_ItemCode,
                      Error: fieldErrors.ItemCode,
                    }} // for select dropdown
                    ParentItemGroup={{
                      ParentItemGroup_list: ParentItemGroup_list,
                      setselect_ParentItemGroup: setselect_ParentItemGroup,
                      select_ParentItemGroup: select_ParentItemGroup,
                      Error: fieldErrors.ParentItemGroup,
                    }}
                    UnicommerceProductCategoryCode={{
                      UnicommerceProductCategoryCode:
                        UnicommerceProductCategoryCode,
                      setUnicommerceProductCategoryCode:
                        setUnicommerceProductCategoryCode,
                      Error: fieldErrors.UnicommerceProductCategoryCode,
                    }}
                    IsGroup={{
                      IsGroup: IsGroup,
                      setIsGroup: setIsGroup,
                      Error: fieldErrors.IsGroup,
                    }}
                  />
                  <Tab2
                    WarrantyExpiryDate={{
                      WarrantyExpiryDate: WarrantyExpiryDate,
                      setWarrantyExpiryDate: setWarrantyExpiryDate,
                      WarrantyExpiryDate: WarrantyExpiryDate,
                      Error: fieldErrors.WarrantyExpiryDate,
                    }}
                    AmcExpiryDate={{
                      AmcExpiryDate: AmcExpiryDate,
                      setAmcExpiryDate: setAmcExpiryDate,
                      AmcExpiryDate: AmcExpiryDate,
                      Error: fieldErrors.AmcExpiryDate,
                    }}
                  />
                  <Tab3
                     Company={{
                      Company_list: Company_list,
                      setselect_Company: setselect_Company,
                      select_Company: select_Company,
                      Error: fieldErrors.Company,
                    }} // for select dropdown
                    WorkOrder={{
                      WorkOrder_list: WorkOrder_list,
                      setselect_WorkOrder: setselect_WorkOrder,
                      select_WorkOrder: select_WorkOrder,
                      Error: fieldErrors.WorkOrder,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default PurchaseSerialList;
